import { PropsWithChildren, PropsWithRef, forwardRef } from "react";
import type { ErrorBoundaryProps } from "react-error-boundary";
import { ErrorBoundary } from "react-error-boundary";

type IAppErrorBoundry = PropsWithRef<PropsWithChildren<ErrorBoundaryProps>>;

export const AppErrorBoundary = forwardRef<ErrorBoundary, IAppErrorBoundry>(
  ({ ...props }, ref) => {
    return <ErrorBoundary {...props} ref={ref} />;
  }
);
